export enum CollaborationReviewViewMode {
  ByVersion = -2,
  All = 0,
  ByStatus = 1,
  ByReviewId = 2,
  MyReviews = 3,
}
